import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
import * as i2 from "@ng-bootstrap/ng-bootstrap";
import * as i3 from "../../pipes/format-list.pipe";
function PopoverListComponent_span_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "formatList");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind3(2, 1, ctx_r0.data.text, ctx_r0.data.separator, ", "));
  }
}
function PopoverListComponent_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r2.data.text);
  }
}
function PopoverListComponent_ng_template_4_span_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 5);
    i0.ɵɵpipe(1, "formatList");
  }
  if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind3(1, 1, ctx_r5.data.text, ctx_r5.data.separator, "<br>"), i0.ɵɵsanitizeHtml);
  }
}
function PopoverListComponent_ng_template_4_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 5);
  }
  if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("innerHTML", ctx_r7.data.text, i0.ɵɵsanitizeHtml);
  }
}
function PopoverListComponent_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, PopoverListComponent_ng_template_4_span_0_Template, 2, 5, "span", 4);
    i0.ɵɵtemplate(1, PopoverListComponent_ng_template_4_ng_template_1_Template, 1, 1, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
  }
  if (rf & 2) {
    const _r6 = i0.ɵɵreference(2);
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r4.data.separator)("ngIfElse", _r6);
  }
}
const _c0 = function (a0) {
  return {
    width: a0
  };
};
export class PopoverListComponent {}
PopoverListComponent.ɵfac = function PopoverListComponent_Factory(t) {
  return new (t || PopoverListComponent)();
};
PopoverListComponent.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
  type: PopoverListComponent,
  selectors: [["app-popover-list"]],
  inputs: {
    data: "data"
  },
  decls: 6,
  vars: 6,
  consts: [["popoverClass", "box-shadow", "triggers", "mouseenter:mouseleave", "placement", "top", "container", "body", 1, "text-container", 3, "ngStyle", "ngbPopover"], [4, "ngIf", "ngIfElse"], ["notFormatted", ""], ["listContainer", ""], [3, "innerHTML", 4, "ngIf", "ngIfElse"], [3, "innerHTML"]],
  template: function PopoverListComponent_Template(rf, ctx) {
    if (rf & 1) {
      i0.ɵɵelementStart(0, "div", 0);
      i0.ɵɵtemplate(1, PopoverListComponent_span_1_Template, 3, 5, "span", 1);
      i0.ɵɵtemplate(2, PopoverListComponent_ng_template_2_Template, 2, 1, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
      i0.ɵɵelementEnd();
      i0.ɵɵtemplate(4, PopoverListComponent_ng_template_4_Template, 3, 2, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
    }
    if (rf & 2) {
      const _r1 = i0.ɵɵreference(3);
      const _r3 = i0.ɵɵreference(5);
      i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(4, _c0, ctx.data.width))("ngbPopover", _r3);
      i0.ɵɵadvance(1);
      i0.ɵɵproperty("ngIf", ctx.data.separator)("ngIfElse", _r1);
    }
  },
  dependencies: [i1.NgIf, i1.NgStyle, i2.NgbPopover, i3.FormatListPipe],
  styles: [".text-container {\n  height: -moz-fit-content;\n  height: fit-content;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  cursor: default;\n}\n\n.list {\n  display: flex;\n  flex-direction: column;\n}\n\n.popover-body {\n  height: -moz-fit-content;\n  height: fit-content;\n  padding: 0.5rem;\n}\n/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"],
  encapsulation: 2
});